module.exports = __webpack_public_path__ + "img/glykosidische-bindung.60941b7e.png";